import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

import { useRouterQuery } from '~hooks/useRouterQuery';
import { del, post, put } from '~lib/api/client';
import useAdminStore from '~store/admin';
import { CompanyStates } from '~types/company';

import useGetCompanyInfo from '../company/useCompanyInfo';

interface MatchParams {
  hash: string;
}

interface UseCompanyCloseMutationParams {
  closedAt: string;
}

/**
 * HASH값을 이용해 redux에 정의되어있는 companyId를 반환
 * @returns companyId
 */
function useGetCompanyId() {
  const companyHash = useRouterQuery('companyId');
  const { data } = useGetCompanyInfo(companyHash);

  return data?.id;
}

/**
 * api요청시 사용되는 payload, 인증에 사용되는 jwt token을 병합하는 함수를 반환
 * @type {{a: boolean}}
 * @returns {function} combineWithSsid
 */
function useCombineWithSsid() {
  const { jwt } = useAdminStore();

  const combineWithSsid = useCallback(
    (payload: Record<string, any>) => {
      return {
        ...payload,
        ssid: jwt,
      };
    },
    [jwt],
  );

  return combineWithSsid;
}

function handleSuccess() {
  alert('Success');
  window.location.reload();
}

// @ts-ignore
function handleError(err) {
  console.log(err);
  alert('Error');
}

/**
 * 기업의 연봉, 인원, 매출, 잡담, 홈 랭킹 노출여부 api
 * @returns
 */
export function useCompanyInfoMutation() {
  const companyId = useGetCompanyId();

  return useMutation(
    (payload?: Partial<Omit<CompanyStates, 'closed' | 'closedAt' | 'deleted'>>) =>
      // @ts-ignore
      post<CompanyStates>(`/api/hq/company/${companyId}/preference`, payload),
    {
      onSuccess: handleSuccess,
      onError: handleError,
    },
  );
}

/**
 * 기업의 폐업여부 api
 * @returns
 */
export function useCompanyCloseMutation() {
  const companyId = useGetCompanyId();

  return useMutation(
    (payload: UseCompanyCloseMutationParams) => post(`/api/hq/company/${companyId}/close`, payload),
    {
      onSuccess: handleSuccess,
      onError: handleError,
    },
  );
}

/**
 * 기업삭제 api
 * @returns
 */
export function useCompanyDeleteMutation() {
  const companyId = useGetCompanyId();

  return useMutation(
    () =>
      del(`/api/hq/company/${companyId}`, {
        data: {},
      }),
    {
      onSuccess: handleSuccess,
      onError: handleError,
    },
  );
}

/**
 * 삭제된 기업 복원 api
 * @returns
 */
export function useCompanyRestoreMutation() {
  const companyId = useGetCompanyId();

  return useMutation(() => put(`/api/hq/company/${companyId}`, {}), {
    onSuccess: handleSuccess,
    onError: handleError,
  });
}
